/* Spanish catalog mirroring locale-payroll-runs-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'pay.overview': 'Resumen de nómina',
  'pay.overviewSub': 'Salarios registrados del ejercicio fiscal, agrupados por empleado.',
  'pay.noPayBasis': 'Todavía no hay base salarial',
  'pay.noPayBasisHint': 'El resumen aparece cuando los procesos de nómina están aprobados o pagados.',
  'pay.noPeriodsHint': 'La cotización del empleador y la retención en origen aparecen cuando hayas aprobado procesos de nómina.',
  'pay.noOtpBasisHint': 'La base de pensión aparece cuando tengas procesos de nómina con importes de pensión.',
  'pay.noHolidayPayHint': 'La base de vacaciones pagadas aparece cuando tengas procesos de nómina aprobados en el periodo seleccionado.',
  'pay.noPayslipsHint': 'Los recibos de nómina aparecen cuando el proceso de nómina tiene empleados.',
  'pay.noInboxVouchersHint': 'Aquí aparecen los justificantes que aún no se han contabilizado.',
  'pay.noEntriesHint': 'Los justificantes contables aparecen después de aprobar el proceso de nómina.',
  'pay.noFixedLinesHint': 'Añade líneas salariales fijas a los empleados para usarlas en los procesos de nómina.',
  'pay.salaryTypeSearchHintFull': 'Primero se muestran los tipos habituales. Busca o elige Mostrar más para ver todo el catálogo activo.',
  'pay.overrideReasonSavedOnLineHint': 'Se guarda en la línea salarial como pista de auditoría.',
  'pay.salaryTypeSearchHintRest': 'Primero se muestran los tipos habituales. Busca o elige Mostrar más para ver el resto.',
  'pay.overrideReasonSavedOnFixedLineHint': 'Se guarda en la línea fija.',
  'pay.payPeriodMonthOnlyHint': 'Los procesos de nómina solo admiten periodos mensuales por ahora.',
  'pay.calculationCodeOtherHint': 'Otros códigos de cálculo estarán disponibles cuando se implementen y verifiquen.',
  'pay.runsAndEmployeesInline': '{{runs}} procesos · {{employees}} empleados',
  'pay.fteShort': 'Jornada:',
  'pay.taxShort': 'Impuestos:',
  'pay.netShort': 'Neto:',
  'pay.holidayPayShort': 'Vac. pag.:',
  'pay.agaShort': 'Cot. emp.:',
  'pay.withholdingHelp': 'Retención en origen: el impuesto deducido del salario bruto y pagado al Estado en nombre del empleado.',
  'pay.holidayPayHelp': 'Vacaciones pagadas devengadas: normalmente el 10,2 % de la base salarial. Se pagan el año siguiente a su devengo.',
  'pay.aga': 'Cotización del empleador',
  'pay.agaHelp': 'Cotización del empleador a la seguridad social sobre el salario: un cargo que el empleador paga al Estado además del coste salarial.',
  'pay.fpShort': 'Vac. pag.:',
  'pay.agaOfHolidayPay': 'Cotización s/ vac. pag.',
  'pay.agaOfHolidayPayHelp': 'Cotización del empleador calculada sobre las vacaciones pagadas devengadas. Se devenga a medida que se devengan las vacaciones pagadas.',
  'pay.fte': 'Equivalentes de jornada completa',
  'pay.fteHelp': 'La proporción de empleo convertida en equivalentes de jornada completa enteros. 1,00 = un puesto completo, 0,50 = medio puesto.',
  'pay.overviewFilteredSub': 'Salarios registrados del ejercicio fiscal, filtrados por fecha de pago.',
  'pay.grouping': 'Agrupación',
  'pay.perEmployee': 'Por empleado',
  'pay.perSalaryType': 'Por tipo de salario',
  'pay.employeeAndType': 'Empleado y tipo de salario',
  'pay.againstWithholding': 'Contra retención en origen',
  'pay.againstAga': 'Contra cotización del empleador',
  'pay.postedAs': 'Contabilizado como:',
  'pay.postedWithholdingOnly': '{{tax}} contra 2600 retención en origen. Pendiente antes del pago: {{openTax}}.',
  'pay.postedAgaOnly': '{{aga}} contra 2770 cotización del empleador. Pendiente antes del pago: {{openAga}}.',
  'pay.postedBoth': '{{tax}} contra 2600 retención en origen y {{aga}} contra 2770 cotización del empleador. Pendiente antes del pago: {{openTax}} de impuestos y {{openAga}} de cotización del empleador.',
  'pay.autoPostedAgainstWithholding': 'El pago se contabiliza automáticamente contra 2600 retención en origen y acredita la cuenta de liquidación seleccionada.',
  'pay.autoPostedAgainstAga': 'El pago se contabiliza automáticamente contra 2770 cotización del empleador y acredita la cuenta de liquidación seleccionada.',
  'pay.autoPostedAgainstBoth': 'El pago se contabiliza automáticamente contra 2600 retención en origen y 2770 cotización del empleador, y acredita la cuenta de liquidación seleccionada.',
  'pay.agreedAnnualSalary': 'Salario anual acordado',
  'pay.agreedHourlyPay': 'Salario por hora acordado',
  'pay.withholdingSeparatePaymentNote': 'La retención en origen de los salarios pagados desde 2026 se paga por separado, a más tardar el primer día hábil posterior al pago de la nómina.',
  'pay.recommendedForOtpPayment': 'Recomendada para el pago de OTP',
  'pay.otpPaymentPostingNote': 'El pago se contabiliza en la cuenta de liquidación seleccionada y lo usa el resumen de Pensión/OTP. Después, el movimiento bancario se puede conciliar con el justificante de pago.',
  'pay.holidayPayAccruedLastYear': 'Vacaciones pagadas, devengadas el año pasado',
  'pay.holidayPayAccruedThisYear': 'Vacaciones pagadas, devengadas este año',
  'pay.ordinaryEmployment': 'Empleo ordinario',
  'pay.payslipUncheckAllNote': 'Desmarca para todos los empleados si los recibos de nómina deben enviarse más tarde. Se pueden enviar desde el proceso de nómina una vez aprobada la contabilización.',
  'pay.payslipPdfNotConnected': 'El PDF del recibo de nómina no está conectado al backend.',
  'pay.noSalaryLines': 'No hay líneas salariales',
  'pay.deletedOn': 'Eliminado el {{date}}',
  'pay.payrollPaymentOn': 'Pago de nómina {{date}}',
  'pay.readyLinesForPayroll': '{{count}} líneas aprobadas listas para la nómina ({{amount}}).',
  'pay.noReadyLinesForPayroll': 'No hay líneas aprobadas listas para la nómina.',
  'pay.overrideAppliesFutureRuns': 'La anulación se aplica a los futuros procesos de nómina que usen esta línea fija.',
  'pay.sentToLabel': 'se envía a',
  'pay.recommendedForPayrollPayment': 'Recomendada para el pago de nómina',
  'pay.optionalNotePh': 'Nota opcional ...',
  'pay.openWithholding': 'Retención en origen pendiente',
  'pay.openAga': 'Cotización del empleador pendiente',
  'pay.noPeriodPayments': 'Todavía no hay pagos registrados para el periodo.',
  'pay.advance': 'Anticipo',
  'pay.agaAndWithholding': 'Cotización del empleador y retención en origen',
  'pay.agaAndWithholdingSub': 'Haz seguimiento de la retención en origen y la cotización del empleador de los procesos de nómina aprobados, por periodo.',
  'pay.withholdingLongHelp': 'El impuesto que has deducido del salario de los empleados. Se mantiene en la cuenta de retención de impuestos y se transfiere al Estado: no es dinero para gastar.',
  'pay.agaLongHelp': 'Un cargo que el empleador paga al Estado sobre salarios y prestaciones. La tasa depende de la zona (municipio) en que se encuentre la empresa: 14,1 % en la zona 1.',
  'pay.toAuthority': 'A Skatteetaten',
  'pay.toAuthorityHelp': 'Retención en origen más cotización del empleador: el total que debe pagarse al Estado por el periodo.',
  'pay.noPeriods': 'Todavía no hay periodos',
  'pay.period2': 'Periodo',
  'pay.payrollRunShort': 'Proceso de nómina',
  'pay.pensionOtp': 'Pensión / OTP',
  'pay.pensionOtpHelp': 'La pensión de empleo obligatoria (OTP) es un ahorro exigido por ley para las pensiones de los empleados: al menos el 2 % del salario. Aquí registras y haces seguimiento de los pagos al proveedor de pensiones de los procesos de nómina aprobados.',
  'pay.pensionPayments': 'Pagos de pensión',
  'pay.pensionPaymentsSub': 'Registra y haz seguimiento de los pagos de OTP de los procesos de nómina aprobados.',
  'pay.newPensionPayment': 'Nuevo pago de pensión',
  'pay.calculatedOtp': 'OTP calculada',
  'pay.calculatedOtpHelp': 'Total de la pensión de empleo obligatoria calculada para el año, a partir de los procesos de nómina aprobados.',
  'pay.open2': 'Pendiente',
  'pay.unpaid': 'Sin pagar',
  'pay.unpaidOtpHelp': 'OTP que se ha calculado pero aún no se ha pagado al proveedor de pensiones.',
  'pay.otp': 'OTP',
  'pay.paidOtpHelp': 'OTP que ya se ha pagado al proveedor de pensiones.',
  'pay.otpPaidWithDifference': 'Pagado {{paid}} · diferencia {{difference}}',
  'pay.noOtpBasis': 'Todavía no hay base de OTP',
  'pay.payPeriod': 'Periodo de pago',
  'pay.pensionPayment': 'Pago de pensión',
  'pay.otpRefPh': 'P. ej. OTP-06',
  'pay.holidayPayList': 'Lista de vacaciones pagadas',
  'pay.holidayPayListSub': 'Vacaciones pagadas devengadas y abonadas de los procesos de nómina aprobados.',
  'pay.holidayPayBasis': 'Base de vacaciones pagadas',
  'pay.earned': 'Devengado',
  'pay.noHolidayPay': 'Todavía no hay vacaciones pagadas',
  'pay.paymentDate': 'Fecha de pago',
  'pay.holidayPayBasisHelp': 'El salario total que da derecho a vacaciones pagadas. Las vacaciones pagadas se calculan como un porcentaje de esta base.',
  'pay.holidayPayEarnedHelp': 'Vacaciones pagadas devengadas hasta ahora: normalmente el 10,2 % de la base (el 12 % con cinco semanas de vacaciones). Se pagan el año siguiente a su devengo.',
  'pay.holidayPayPaidHelp': 'Vacaciones pagadas ya abonadas a los empleados este año.',
  'pay.voucherShort': 'Justif.:',
  'pay.paidOutShort': 'Pagado:',
  'pay.earnedShort': 'Devengado:',
  'pay.paidShort': 'Abonado:',
  'pay.salaryLine': 'Línea salarial',
  'pay.newLine': 'Crear una nueva línea',
  'pay.taxResidentCountry': 'País de residencia fiscal',
  'pay.earningCountry': 'País de obtención',
  'pay.earningRelation': 'Relación de obtención',
  'pay.noPrefill': 'No rellenar previamente el importe/cantidad de esta línea en los nuevos procesos de nómina',
  'pay.holidayPayPayout': 'Pago de vacaciones pagadas',
  'pay.addHolidayPay': 'Añadir vacaciones pagadas',
  'pay.earnedEarlier': 'Devengado anteriormente',
  'pay.earnedThisYear': 'Devengado este año',
  'pay.pensionContribution': 'Aportación/prima de pensión',
  'pay.registerPensionContribution': 'Registrar aportación/prima de pensión',
  'pay.fetchNavRefunds': 'Obtener reembolsos de NAV',
  'pay.fetchNavRefundsSub': 'Obtén los reembolsos que se incluirán en el proceso de nómina.',
  'pay.emailPayslips': 'Enviar recibos de nómina por correo',
  'pay.sendPayslips': 'Enviar recibos de nómina',
  'pay.sendLater': 'Enviar más tarde',
  'pay.sendPayslip': 'Enviar recibo de nómina',
  'pay.sendAllPayslips': 'Enviar a todos',
  'pay.sending': 'Enviando ...',
  'pay.payslipSendFailed': 'No se pudo enviar el recibo de nómina.',
  'pay.payslipSendUnavailable': 'El envío de recibos de nómina no está conectado al backend.',
  'pay.downloadPayslip': 'Descargar recibo de nómina',
  'pay.downloadAllPdf': 'Descargar todos (PDF)',
  'pay.downloading': 'Descargando ...',
  'pay.sendTime': 'Momento del envío',
  'pay.payslipsAfterPosting': 'Los recibos de nómina se pueden descargar una vez contabilizado el proceso de nómina.',
  'pay.noPayslipsShort': 'Sin recibos de nómina',
  'pay.paymentInfo': 'Información de pago',
  'pay.copyToClipboard': 'Copiar al portapapeles',
  'pay.downloadExcel': 'Descargar Excel',
  'pay.registerPayment': 'Registrar pago',
  'pay.paymentsFromOperating': 'Pagos desde la cuenta operativa:',
  'pay.toBankAccount': 'A la cuenta bancaria',
  'pay.paidOutDate': 'Fecha de pago',
  'pay.bankTip': '¡Consejo! No olvides realizar el pago efectivo de la retención en origen y del salario en tu banca en línea.',
  'pay.linkVoucher': 'Vincular justificante',
  'pay.noInboxVouchers': 'No hay justificantes en la bandeja de entrada',
  'pay.newSalaryLine': 'Nueva línea salarial',
  'pay.paidOutVerb': 'Pagado',
  'pay.agaShort2': 'Cot. emp.',
  'pay.holiday': 'Vacaciones',
  'pay.noExtraLines': 'Todavía no se han añadido líneas salariales adicionales.',
  'pay.showEmployeePage': 'Ver página del empleado',
  'pay.addSalaryLine': 'Añadir línea salarial',
  'pay.noEmployeesInRun': 'No hay empleados en el proceso de nómina',
  'pay.holidayPensionDeductions': 'Vacaciones pagadas, pensión y deducciones',
  'pay.pensionContributionOrPremium': 'Aportación o prima de pensión',
  'pay.summary': 'Resumen',
  'pay.payrollRun': 'Proceso de nómina',
  'pay.agaRate': 'Cot. del empleador (14,1 %)',
  'pay.posting': 'Asiento contable',
  'pay.writeComment': 'Escribir un comentario',
  'pay.seePayslips': 'Ver recibos de nómina',
  'pay.nextStep': 'Siguiente paso',
  'pay.sendAmeldingToAltinn': 'Enviar la a-melding a Altinn',
  'pay.deletePayrollRun': 'Eliminar proceso de nómina',
  'pay.manualSubmission': 'Envío manual',
  'pay.sendAmelding': 'Enviar a-melding',
  'pay.altinnConfirmation': 'Confirmación de Altinn',
  'pay.altinnConfirmationHelp': 'Una vez enviada la a-melding, esperas la confirmación antes de que se creen los recibos de nómina.',
  'pay.createPayslips': 'Crear recibos de nómina',
  'pay.editPayrollRun': 'Editar proceso de nómina',
  'pay.registerPaymentToEmployees': 'Registrar el pago a empleados e impuestos',
  'pay.cancelPosting': 'Cancelar la contabilización',
  'pay.cancelPostingConfirmTitle': '¿Cancelar el asiento contable?',
  'pay.cancelPostingConfirmMessage': 'Esto devuelve el proceso de nómina a borrador. Los pagos registrados y el asiento contable se cancelan y se eliminan de los totales contables activos. Tendrás que revisar y aprobar el proceso de nómina de nuevo.',
  'pay.cancelPostingConfirmAction': 'Cancelar el asiento contable',
  'pay.keepPosting': 'Mantener el asiento contable',
  'pay.seeAccountingVoucher': 'Ver justificante contable',
  'pay.registerPayments': 'Registrar pagos',
  'pay.payrollDone': '¡La nómina está ejecutada y contabilizada!',
  'pay.payrollDoneSub': 'El proceso de nómina se ha presentado, contabilizado y registrado como pagado.',
  'pay.allPayrollRuns': 'Todos los procesos de nómina',
  'pay.noEntries': 'Sin asientos',
  'pay.calculatedWithholding': 'Retención en origen calculada',
  'pay.toPayOut': 'Por pagar',
  'pay.activePayrollRuns': 'Procesos de nómina activos',
  'pay.runsCount': '{{count}} procesos',
  'pay.employeesInActiveRuns': '{{count}} empleados en procesos activos',
  'pay.createNewRunHint': 'Crea un nuevo proceso de nómina para incorporar empleados, líneas salariales fijas y gastos de viaje aprobados.',
  'pay.activePayrollRunsHelp': 'Un proceso de nómina calcula el salario, la retención en origen, las vacaciones pagadas y la cotización del empleador de un periodo. Los procesos activos están en curso.',
  'pay.newPayrollRun': 'Nuevo proceso de nómina',
  'pay.noActiveRuns': 'No hay procesos de nómina activos',
  'pay.earlierPayrollRuns': 'Procesos de nómina anteriores',
  'pay.earlierPayrollRunsHelp': 'Procesos de nómina cuyos pagos se han registrado. Puedes abrirlos para ver detalles, recibos de nómina y justificantes contables.',
  'pay.orderNumberDate': 'Primero el pago más reciente',
  'pay.travelAndExpenses': 'Viajes y gastos',
  'pay.createPayrollRun': 'Crear un nuevo proceso de nómina',
  'pay.payrollRunDate': 'Fecha del proceso de nómina',
  'pay.payPeriodMonthHelp': 'El mes al que corresponde el salario. La fecha de pago puede ser otra distinta.',
  'pay.paymentDateHelp': 'La fecha en que el dinero se paga realmente. No cambia el periodo de nómina.',
  'pay.paymentDatePeriodWarning': 'La fecha de pago queda fuera del mes habitual del periodo de nómina. Comprueba que el periodo y la fecha sean correctos.',
  'pay.includeFixedLines': 'Incluir líneas salariales recurrentes',
  'pay.includeExpenseLines': 'Incluir líneas de gastos',
  'pay.readyExpenseLineCount': '{count} líneas listas para el pago',
  'pay.payPeriodLength': 'Periodo de pago (duración del devengo)',
  'pay.ordinaryWithholding': 'Retención en origen ordinaria',
  'pay.useTaxCard': 'Usar la tarjeta fiscal cuando esté disponible',
  'pay.optionalComment': 'Comentario opcional',
  'pay.salaryTypesAndDeductions': 'Tipos de salario y deducciones',
  'pay.salaryTypesHelp': 'Los tipos de salario controlan cómo se trata una línea salarial en la cotización del empleador, la retención en origen, las vacaciones pagadas y la pensión.',
  'pay.newSalaryType': 'Nuevo tipo de salario',
  'pay.agaLiableHelp': 'Si el tipo de salario forma parte de la base de la cotización del empleador. Marcado = sujeto.',
  'pay.withholdingLiableHelp': 'Si el tipo de salario está sujeto a retención, es decir, si debe deducirse el anticipo de impuestos del importe.',
  'pay.holidayPayLiableHelp': 'Si el tipo de salario genera base de vacaciones pagadas, es decir, si el importe devenga vacaciones pagadas.',
  'pay.pension': 'Pensión',
  'pay.pensionLiableHelp': 'Si el tipo de salario forma parte de la base de la pensión de empleo obligatoria (OTP).',
  'pay.rules': 'Reglas',
  'pay.noLiabilityRules': 'Sin reglas de cotización ni de retención',
  'pay.noEffect': 'Sin efecto',
  'pay.bonusExamplePh': 'P. ej. bonus sin vacaciones pagadas',
  'pay.benefitInKind': 'Retribución en especie',
  'pay.deduction': 'Deducción',
  'pay.taxFreeAllowance': 'Asignación exenta de impuestos',
  'pay.overrideNote': 'Los cambios se guardan como anulación del tipo estándar por parte de la empresa.',
  'pay.ratePerMonth': 'Tarifa (por mes)',
  'pay.calculated': 'Calculado',
  'pay.changeCountries': 'Cambiar país de obtención/residencia',
  'pay.optionalCommentPh': 'Comentario opcional ...',
  'pay.fixedSalaryLines': 'Líneas salariales recurrentes',
  'pay.fixedSalaryLinesSub': 'Líneas salariales que se repiten automáticamente en cada proceso de nómina.',
  'pay.addFixedLine': 'Añadir línea salarial recurrente',
  'pay.noFixedLines': 'No hay líneas salariales recurrentes',
  'pay.payrollSettings': 'Ajustes de nómina',
  'pay.payrollSettingsSub': 'Valores predeterminados que usa Plumme al contabilizar salarios, cotización del empleador, vacaciones pagadas y pensión.',
  'pay.contributionAndHoliday': 'Cotización y vacaciones pagadas',
  'pay.agaZone': 'Zona de cotización del empleador',
  'pay.holidayPayRate': 'Tasa de vacaciones pagadas',
  'pay.pensionOtpShort': 'Pensión (OTP)',
  'pay.pensionProvider': 'Proveedor de pensiones',
  'pay.providerOrgNo': 'N.º de empresa del proveedor',
  'pay.otpRate': 'Tasa de OTP',
  'pay.accountsAndReporting': 'Cuentas y declaraciones',
  'pay.payrollAccount': 'Cuenta de nómina (banco)',
  'pay.withholdingAccount': 'Cuenta de retención de impuestos',
  'pay.firstPayrollYear': 'Primer año para contabilizar la nómina',
  'pay.entityNumber': 'Número de entidad',
  'pay.holidayPayPercent': 'Porcentaje de vacaciones pagadas',
  'pay.holidayPayPercentHelp': 'La tasa a la que se devengan las vacaciones pagadas. El 10,2 % es el mínimo legal; el 12 % se aplica cuando se han acordado cinco semanas de vacaciones.',
  'pay.holidayPayMonth': 'Mes de las vacaciones pagadas',
  'pay.month.january': 'Enero',
  'pay.month.february': 'Febrero',
  'pay.month.march': 'Marzo',
  'pay.month.april': 'Abril',
  'pay.month.june': 'Junio',
  'pay.month.july': 'Julio',
  'pay.month.august': 'Agosto',
  'pay.month.september': 'Septiembre',
  'pay.month.october': 'Octubre',
  'pay.month.november': 'Noviembre',
  'pay.month.december': 'Diciembre',
  'pay.shift.none': 'Sin trabajo por turnos',
  'pay.shift.shift': 'Trabajo por turnos',
  'pay.shift.rota': 'Turnos rotativos',
  'pay.shift.continuous': 'Trabajo por turnos continuo',
  'pay.ordinary': 'Ordinario',
  'pay.maritime': 'Marítimo',
  'pay.freelancer': 'Autónomo',
  'pay.pensionOrOtherBenefit': 'Pensión u otra prestación',
  'pay.municipalityAndNumber': 'Municipio y número de municipio',
  'pay.pickMunicipality': 'Elige un municipio',
  'pay.calculationCode': 'Código de cálculo',
  'pay.generalIndustries': 'Industrias generales',
  'pay.agricultureForestry': 'Agricultura y silvicultura',
  'pay.fishing': 'Pesca y caza',
  'pay.pensionProviderOtp': 'Proveedor de pensiones (OTP)',
  'pay.withholdingAccounts': 'Cuentas de retención',
  'pay.payoutAccount': 'Cuenta para el pago de salarios',
  'pay.amelding': 'A-melding',
  'pay.everyMonth': 'Cada mes',
  'pay.everyPayrollRun': 'En cada proceso de nómina',
  'pay.taxCardChangeAlert': 'Alerta de cambios en la tarjeta fiscal',
  'pay.emailPh': 'nombre@empresa.com',
  'pay.sms': 'SMS',
  'pay.savingsAccount': 'Cuenta de ahorro',
  'pay.withholdingMode.fiftyPercent': '50 % de retención en origen',
  'pay.withholdingMode.standardHint': 'Usa la tarjeta fiscal válida registrada en el empleado. Si no hay ninguna, se retiene el 50 %.',
  'pay.withholdingMode.taxCardHint': 'Las tarjetas fiscales aún no se obtienen automáticamente de la Administración Tributaria noruega. Plumme usa la tarjeta fiscal registrada en el empleado y retiene el 50 % cuando no existe una tarjeta fiscal válida.',
  'pay.withholdingMode.fiftyPercentHint': 'Retiene el 50 % de la base imponible de cada empleado de este proceso de nómina, con independencia de la tarjeta fiscal.',
  'pay.holidayPayPrevious.hint': 'Lo devengado el año pasado se calcula a partir de los procesos de nómina aprobados del año pasado, menos lo que ya se ha pagado. Las vacaciones pagadas devengadas antes de empezar a usar Plumme no se incluyen: ajusta el importe con el lápiz.',
  'pay.deductionAccount.label': 'Cuenta que se acredita con la deducción',
  'pay.deductionAccount.hint': 'Las deducciones que se transfieren a terceros son pasivos. Elige 2610 para embargo de salario. Plumme no declara el embargo en la a-melding: la deducción debe pagarse por separado.',
  'pay.deductionAccount.canteen': '5919 Deducción de coste de comedor de empleados',
  'pay.deductionAccount.garnishment': '2610 Embargo de salario',
  'pay.deductionAccount.unionDues': '2650 Cuotas sindicales retenidas',
  'pay.deductionAccount.other': '2690 Otras deducciones',
  'pay.taxRuleUnsupportedError': 'Plumme aún no admite {rule}: ejecuta la nómina de {employee} fuera de Plumme.',
  'err.payroll.unsupportedTaxRule': 'Un empleado del proceso de nómina tiene una norma fiscal que Plumme aún no admite. Ejecuta la nómina de este empleado fuera de Plumme.',
  'pay.taxRules.svalbard': 'Svalbard',
  'pay.taxRules.janMayen': 'Jan Mayen y las dependencias noruegas',
  'pay.taxRules.seafarerDeduction': 'la deducción especial para marinos',
  'pay.taxRules.charity': 'organización benéfica o sin ánimo de lucro',
  'pay.taxRules.netPay': 'salario neto',
  'pay.taxRules.netPaySeafarer': 'salario neto para marinos',
  'pay.taxRules.pensionSourceTax': 'retención en origen sobre pensiones',
  'pay.taxRules.nanny': 'niñera en el hogar del niño',
  'pay.taxRules.homeWork': 'trabajo remunerado en el hogar',
  'pay.taxRules.taxFreeOrganization': 'organización exenta de impuestos',
  'pay.pensionAllocation.explain': 'La prima sustituye a la pensión de empleo (OTP) calculada para los empleados que elijas. Si eliges varios, el importe se reparte según su base de OTP.',
  'pay.pensionAllocation.employees': 'Empleados a los que se aplica la prima',
  'pay.pensionAllocation.amountRequired': 'Introduce un importe mayor que 0.',
  'pay.pensionAllocation.noEmployees': 'Elige al menos un empleado al que se aplique la prima.',
  'pay.pensionAllocation.noBasis': 'Los empleados elegidos no tienen base de OTP en este proceso de nómina. Elige un empleado o añade primero un salario.',
  'pay.pensionAllocation.noLines': 'El proceso de nómina no tiene empleados a los que asignar la prima de pensión.',
  'pay.pensionAllocation.saveFailed': 'No se pudo registrar la prima de pensión.',
  'pay.travelNotPayableError': 'Estas solicitudes de viaje o gastos ya no se pueden pagar a través de este proceso de nómina: {travels}. Ya se pagaron en otro proceso o no están aprobadas. Quítalas del borrador o revierte el proceso que las pagó.',
  'err.payroll.travelNotPayable': 'Una solicitud de viaje o gastos de este proceso de nómina ya se pagó en otro proceso o ya no está aprobada. Quita la línea del borrador antes de aprobar.',
  'pay.noCalculationBasis': 'Sin base de cálculo',
  'pay.payTypeGroup.common': 'Habituales',
  'pay.payTypeGroup.custom': 'Tipos de salario personalizados',
  'pay.payTypeGroup.other': 'Otros tipos de salario',
  'pay.payTypeGroup.benefitInKind': 'Retribuciones en especie',
  'pay.payTypeGroup.deduction': 'Deducciones',
  'pay.payTypeGroup.taxFreeAllowance': 'Asignaciones exentas de impuestos',
  'pay.inactive': 'inactivo',
  'pay.selectSalaryType': 'Seleccionar tipo de salario',
  'pay.searchSalaryTypeOrRule': 'Buscar por tipo de salario o regla',
  'pay.showMoreSalaryTypes': 'Mostrar más tipos de salario',
  'pay.calculationRules': 'Reglas de cálculo',
  'pay.agaAndTaxTab': 'Cotización del empleador e impuestos',
  'pay.pensionOtpTab': 'Pensión/OTP',
  'pay.zone': 'Zona',
  'pay.status.paid': 'Pagado',
  'pay.status.unpaid': 'Sin pagar',
  'pay.status.approved': 'Aprobado',
  'pay.status.annulled': 'Anulado',
  'pay.status.draft': 'Borrador',
  'pay.status.partiallyPaid': 'Pagado parcialmente',
  'pay.select': 'Seleccionar',
  'pay.search': 'Buscar',
  'pay.noDataYet': 'Todavía no hay datos',
  'pay.noDataYetBody': 'Cuando haya registros, aparecerán aquí.',
  'pay.notSet': 'Sin definir',
  'pay.thisIsADeduction': 'Esto es una deducción',
  'pay.fixedLineHint.payout': 'La línea se paga al empleado',
  'pay.fixedLineHint.taxable': 'Sujeta a impuestos: incluida en la retención',
  'pay.fixedLineHint.employerContribution': 'Incluida en la base de la cotización del empleador',
  'pay.fixedLineHint.holidayPay': 'Incluida en la base de vacaciones pagadas',
  'pay.fixedLineHint.pension': 'Incluida en la base de la pensión de empleo (OTP)',
  'pay.fixedLineHint.deduction': 'Importe negativo: se deduce del pago',
  'pay.amountMustBePositive': 'El importe debe ser mayor que 0.',
  'pay.amountExceedsOpenTerm': 'El importe no puede ser superior al saldo pendiente del periodo.',
  'pay.allocationMustMatchAmount': 'La asignación debe coincidir con el importe y no puede superar el importe pendiente.',
  'pay.paymentUpdated': 'Pago actualizado.',
  'pay.paymentRegistered': 'Pago registrado.',
  'pay.savePaymentFailed': 'No se pudo guardar el pago.',
  'pay.paymentAnnulled': 'Pago anulado.',
  'pay.annulPaymentFailed': 'No se pudo anular el pago.',
  'pay.allPensionPaymentsRegistered': 'Todos los pagos de pensión están registrados.',
  'pay.noOtpToRegisterYet': 'Todavía no hay OTP calculada que registrar.',
  'pay.missingPayrollRunForOtp': 'Falta el proceso de nómina para el pago de OTP.',
  'pay.pensionPaymentRegistered': 'Pago de pensión registrado.',
  'pay.registerPensionPaymentFailed': 'No se pudo registrar el pago de pensión.',
  'pay.explainRuleOverrideRequired': 'Explica por qué se anulan las reglas de cálculo.',
  'pay.navRefundsFetched': 'Reembolsos de NAV obtenidos.',
  'pay.navRefundsFetchFailed': 'No se pudieron obtener los reembolsos de NAV.',
  'pay.payslipDownloaded': 'Recibo de nómina descargado.',
  'pay.payslipDownloadFailed': 'No se pudo descargar el recibo de nómina.',
  'pay.payslipsDownloaded': 'Recibos de nómina descargados.',
  'pay.payslipsDownloadFailed': 'No se pudieron descargar los recibos de nómina.',
  'pay.paymentInfoCopied': 'Información de pago copiada.',
  'pay.paymentFileDownloaded': 'Archivo de pago descargado.',
  'pay.linkInboxDocumentFailed': 'No se pudo vincular el justificante de la bandeja de entrada.',
  'pay.payrollRunCreated': 'Proceso de nómina creado.',
  'pay.payrollRunCreateFailed': 'No se pudo crear el proceso de nómina.',
  'pay.payrollRunUpdateFailed': 'No se pudo actualizar el proceso de nómina.',
  'pay.deletedPayrollRunRemoved': 'Proceso de nómina eliminado quitado.',
  'pay.removePayrollRunFailed': 'No se pudo quitar el proceso de nómina.',
  'pay.commentSaved': 'Comentario guardado.',
  'pay.salaryLineAdded': 'Línea salarial añadida.',
  'pay.voucherLinkedToPayrollRun': 'Justificante vinculado al proceso de nómina.',
});
